import {connect} from 'react-redux'
import * as usersActions from "../actions/usersActions";
import UsersDialog from "../../Components/Toolbars/TopToolbar/UsersDialog/UsersDialog";

const mapStateToProps = (store) => {
    return {
        users: store.usersReducer.users.filter(u => !u.isHidden),
        profiles: store.profilesReducer.profiles
    };
};

const mapDispatchToProps = {
    addUser: usersActions.addUserAction,
    editUser: usersActions.editUserAction,
    deleteUser: usersActions.deleteUserAction
};

const UsersDialogContainer = connect(mapStateToProps, mapDispatchToProps)(UsersDialog);

export default UsersDialogContainer;